module.exports = __webpack_public_path__ + "img/12.8858be54.jpg";